<script lang="tsx">
  import { defineComponent, computed, PropType } from 'vue'

  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '@xhs/yam-beer/core'

  import LoadingSpinner from './LoadingSpinner.vue'
  import BeerText from '../Text/Text.vue'

  /**
   * 适合用在控件内部的组件
   */
  export default defineComponent({
    name: 'WidgetLoading',
    components: {
      NewBsBox,
      BeerText,
      LoadingSpinner,
    },
    props: {
      /**
       * @ignore
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       */
      textBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 加载中的文案
       * */
      text: {
        type: String as PropType<string>,
        default: '加载中…',
      },
    },
    setup(props, { slots, attrs }) {
      const mergedTextBs = computed(() => ({
        ml: 8,
        ...(props.textBs || {}),
      }))
      return () => (
            <LoadingSpinner bs={{
              display: 'flex',
              color: 'mute',
              flexDirection: 'row',
              alignItems: 'center',
              ...props.bs,
            }} {...{ size: 18, ...attrs }} v-slots={{
              text() {
                return (
                  slots.text
                    ? slots.text()
                    : <NewBsBox bs={mergedTextBs.value}>{props.text}</NewBsBox>
                )
              },
            }}>
            </LoadingSpinner>
        )
    },
  })
</script>
